import React from "react";
import { useLanguage } from "./LanguageContext";
import Icon from "components/AppIcon";

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();

  const toggleLanguage = () => {
    changeLanguage(language === "en" ? "ar" : "en");
  };

  return (
    <button
      onClick={toggleLanguage}
      className="inline-flex items-center gap-2 rounded-full border border-[rgba(28,83,2,0.18)] bg-white/85 px-3 py-2 text-sm font-semibold text-[#1C5302] backdrop-blur transition-colors hover:bg-white"
      type="button"
    >
      <Icon name="Globe" size={18} />
      <span>{language === "en" ? "العربية" : "English"}</span>
    </button>
  );
};

export default LanguageSwitcher;
